import { isIOS, isIOSInApp, isChromeIOS, isFirefoxIOS } from '~/utils/user-agent-utils';
import { getAppUrlScheme, isSwishSupportedOnApp } from '~/components/app-bridge/app-properties.js';
import { isBridgeAvailable } from '~/components/app-bridge/index.js';

const getIOSRedirect = () => {
	// for ios chrome & ios mozilla, change the protocol to chrome to prevent redirection to safari
	const url = isChromeIOS()
		? encodeURIComponent('googlechromes://')
		: isFirefoxIOS()
			? encodeURIComponent('firefox://')
			: 'no-return';
	return url;
};

const getSwishAppRedirectUrl = () => {
	const appUrlScheme = getAppUrlScheme();

	switch (true) {
		case !!appUrlScheme: // redirect for our native apps
			return encodeURIComponent(`${appUrlScheme}://`);
		case !window.appProperties && isIOSInApp(): // for in-app browsers on ios except our app
			return 'no-return';
		case isIOS():
			return getIOSRedirect();

		default:
			return 'no-return';
	}
};

const isAppSupportsSwish = () => !isBridgeAvailable() || isSwishSupportedOnApp(); // if opened in our native app, check the Swish feature support

export { getSwishAppRedirectUrl, isAppSupportsSwish };
